export const stringHash = (str?: string | null): number => {
  let hash = 0;

  if (str?.length) {
    for (let i = 0; i < str.length; i++) {
      const chr = str.charCodeAt(i);

      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
  }

  return hash;
};
